"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPenOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M17.005 2.755c.948-.94 1.89-.94 2.828-.001 1.407 1.409-.002-.004 1.408 1.408.94.94.94 1.883-.003 2.825l-2.83 2.83-4.232-4.233 2.829-2.83zm1.411 1.41L17.001 5.58l1.411 1.41 1.415-1.413-1.411-1.411v-.001zM12.929 6.81l4.233 4.233L7.088 21.117l-3.841.784a1.163 1.163 0 01-.89-.195c-.266-.186-.37-.516-.312-.993l.81-3.828L12.93 6.81h-.001zm0 2.84l-7.95 7.952-.71 2.12 2.12-.71 7.952-7.95-1.411-1.411-.001-.001z' }))); };
exports.default = SvgPenOutline;
//# sourceMappingURL=PenOutline.js.map